import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { fetchDepartments, createContact } from '../../services/apiService';
import ToastService from '../../services/toastService';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
// import pic1 from "../../images/about/pic-1.jpg";
import icon1 from "../../images/icon/icon1.svg";
import icon2 from "../../images/icon/icon2.svg";
import icon3 from "../../images/icon/icon3.svg";
import animateWave from "../../images/shap/wave-blue.png";
import animate2 from "../../images/shap/circle-dots.png";
import animateRotate from "../../images/shap/plus-blue.png";


const ContactUs = () => {
	const [departments, setDepartments] = useState([]);
	const [loading, setLoading] = useState(false);
	const [fetching, setFetching] = useState(false);
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset
	} = useForm();

	const onSubmit = async (data) => {
		setLoading(true);
		try {
			const response = await createContact(data);
			if (response.status === 200) {
				ToastService.success(response.data.message);
				reset();
			} else {
				ToastService.error(response.data.message || "Failed to send message");
			}
		} catch (error) {
			ToastService.error(error?.response?.data?.message);
		}finally {
			setLoading(false);
		}
	};

	const getDepartments = async () => {
		setFetching(true);
		try {
			const response = await fetchDepartments();
			if (response.status === 200) {
				setDepartments(response?.data?.data || []);
			} else {
				console.error("Failed to fetch departments:", response.statusText);
			}
		} catch (error) {
			console.error("Error fetching departments:", error);
		} finally {
			setFetching(false);
		}
	};

	useEffect(() => {
		getDepartments();
	}, []);

	return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner banner-lg contact-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Contact Us</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Contact Us</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={animateWave} alt=""/>
							<img className="pt-img2 animate2" src={animate2} alt=""/>
							<img className="pt-img3 animate-rotate" src={animateRotate} alt=""/>
						</div>
					</div>
					
					<section className="">
						<div className="container">
							<div className="contact-wraper">
								<div className="row">
									<div className="col-lg-6 mb-30">
										<form onSubmit={handleSubmit(onSubmit)} className="form-wraper contact-form" noValidate style={{position: "relative"}}>
											<div className='h-100' style={{display: fetching ? 'block' : 'none', position: 'absolute', inset: '0px', background: 'rgb(255 255 255 / 66%)', zIndex: '1'}}> 
												<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{position: 'absolute', top: '45%', left: '45%'}}></span> 
											</div>
											<div className="row">
												<div className="form-group col-md-12">
													<input
														type="text"
														className="form-control"
														placeholder="Your Name"
														{...register("name", { required: "Name is required" })}
													/>
													{errors.name && <small className="text-danger">{errors.name.message}</small>}
												</div>

												<div className="form-group col-md-12">
													<input
														type="email"
														className="form-control"
														placeholder="Email"
														{...register("email", {
															required: "Email is required",
															pattern: {
																value: /^\S+@\S+$/i,
																message: "Invalid email address"
															}
														})}
													/>
													{errors.email && <small className="text-danger">{errors.email.message}</small>}
												</div>

												<div className="form-group col-md-12">
													<input
														type="text"
														className="form-control"
														placeholder="Phone Number"
														{...register("phone", {
															required: "Phone number is required",
															pattern: {
																value: /^[0-9]{10}$/,
																message: "Phone number must be 10 digits"
															}
														})}
													/>
													{errors.phone && <small className="text-danger">{errors.phone.message}</small>}
												</div>

												<div className="form-group col-md-12">
													<i className='fas fa-chevron-down' style={{right: "30px"}}></i>
													<select
														className="form-select form-control"
														{...register("departmentId", {
															required: "Please select a department"
														})}
													>
														<option value="">Select Department</option>
														{departments.length > 0 && departments.map((department) => (
															<option key={department._id} value={department._id}>
																{department.name}
															</option>
														))}
													</select>
													{errors.department && <small className="text-danger">{errors.departmentId.message}</small>}
												</div>

												<div className="form-group col-md-12">
													<textarea
														rows="10"
														className="form-control"
														placeholder="Write Message"
														{...register("message", { required: "Message is required" })}
													></textarea>
													{errors.message && <small className="text-danger">{errors.message.message}</small>}
												</div>

												<div className="col-lg-12">
													<button type="submit" className="btn w-100 btn-primary btn-sm" disabled={loading}>
														{loading ? (
															<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
														) : 'Submit'}
													</button>
												</div>
											</div>
										</form>
									</div>
									<div className="col-lg-6 mb-30">
										<div className="contact-info" style={{backgroundColor: "#6F74F0F0"}}>
											<div className="info-inner">
												<h6 className="title mb-30 text-uppercase">Have a question?</h6>
												<div className="icon-box">
													<p className="title">
														<svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M10.9995 23.018C13.608 20.6829 15.6041 18.4432 16.9879 16.2987C18.3717 14.1543 19.0635 12.276 19.0635 10.664C19.0635 8.23337 18.2913 6.23515 16.7469 4.66937C15.2024 3.1036 13.2867 2.32071 10.9995 2.32071C8.71244 2.32071 6.79666 3.1036 5.25221 4.66937C3.70777 6.23515 2.93555 8.23337 2.93555 10.664C2.93555 12.276 3.62744 14.1543 5.01121 16.2987C6.39499 18.4432 8.3911 20.6829 10.9995 23.018ZM10.9995 24.9204C10.7398 24.9204 10.48 24.8756 10.2202 24.786C9.96021 24.6963 9.7251 24.5574 9.51488 24.3694C8.31844 23.2667 7.19877 22.1312 6.15588 20.9627C5.11321 19.7945 4.20688 18.6266 3.43688 17.459C2.66666 16.2915 2.05721 15.1343 1.60855 13.9874C1.15988 12.8403 0.935547 11.7325 0.935547 10.664C0.935547 7.58715 1.93077 5.09615 3.92121 3.19104C5.91188 1.28593 8.27132 0.333374 10.9995 0.333374C13.7278 0.333374 16.0872 1.28593 18.0779 3.19104C20.0683 5.09615 21.0635 7.58715 21.0635 10.664C21.0635 11.7325 20.8392 12.838 20.3905 13.9807C19.9419 15.1236 19.3347 16.2809 18.5689 17.4527C17.8029 18.6245 16.8985 19.7924 15.8559 20.9564C14.8132 22.1206 13.6935 23.2539 12.4969 24.3564C12.2898 24.5444 12.0543 24.6854 11.7905 24.7794C11.527 24.8734 11.2633 24.9204 10.9995 24.9204ZM11.0019 12.8204C11.6652 12.8204 12.2323 12.5842 12.7032 12.1117C13.1743 11.6393 13.4099 11.0714 13.4099 10.408C13.4099 9.74471 13.1737 9.17749 12.7012 8.70637C12.2288 8.23549 11.6608 8.00004 10.9972 8.00004C10.3339 8.00004 9.76677 8.23626 9.29588 8.70871C8.82477 9.18115 8.58921 9.74915 8.58921 10.4127C8.58921 11.076 8.82544 11.6432 9.29788 12.114C9.77033 12.5849 10.3383 12.8204 11.0019 12.8204Z" fill="white"/>
														</svg>
														<span className='ms-3'>Address</span>
													</p>		
													<p style={{fontWeight:"300"}}>Plot No. 94B, Second Floor, Udyog Vihar Phase V Rd, Udyog Vihar, Sector 19, Gurugram, Haryana 122016</p>
												</div>
												<div className="icon-box">
													<p className="title">
														<svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M2.74334 20C2.06979 20 1.49967 19.7667 1.03301 19.3C0.566341 18.8333 0.333008 18.2632 0.333008 17.5897V2.41033C0.333008 1.73678 0.566341 1.16667 1.03301 0.7C1.49967 0.233333 2.06979 0 2.74334 0H23.256C23.9296 0 24.4997 0.233333 24.9663 0.7C25.433 1.16667 25.6663 1.73678 25.6663 2.41033V17.5897C25.6663 18.2632 25.433 18.8333 24.9663 19.3C24.4997 19.7667 23.9296 20 23.256 20H2.74334ZM23.6663 3.923L13.6483 10.336C13.5459 10.394 13.4399 10.4397 13.3303 10.473C13.221 10.5063 13.1108 10.523 12.9997 10.523C12.8886 10.523 12.7783 10.5063 12.669 10.473C12.5595 10.4397 12.4535 10.394 12.351 10.336L2.33301 3.923V17.5897C2.33301 17.7094 2.37145 17.8078 2.44834 17.8847C2.52523 17.9616 2.62356 18 2.74334 18H23.256C23.3758 18 23.4741 17.9616 23.551 17.8847C23.6279 17.8078 23.6663 17.7094 23.6663 17.5897V3.923ZM12.9997 8.66667L23.4613 2H2.53801L12.9997 8.66667ZM2.33301 4.23067V2.70633V2.746V2.70367V4.23067Z" fill="white"/>
														</svg>
														<span className='ms-3'>Email</span>
													</p>				
													<Link to="mailto:info@avenrahealthcenter.in" className="text-white" style={{fontWeight:"300"}}>info@avenrahealthcenter.in</Link>
												</div>
												<div className="icon-box mb-0">
													<p className="title">
														<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M21.9207 23.3333C19.408 23.3333 16.8837 22.7491 14.3477 21.5806C11.8119 20.4122 9.48199 18.764 7.35799 16.636C5.23421 14.5077 3.5881 12.1777 2.41966 9.64596C1.25121 7.1144 0.666992 4.59229 0.666992 2.07963C0.666992 1.67585 0.800326 1.3394 1.06699 1.07029C1.33366 0.801181 1.66699 0.666626 2.06699 0.666626H6.41566C6.75233 0.666626 7.04933 0.776515 7.30666 0.996293C7.56399 1.21585 7.72766 1.48718 7.79766 1.81029L8.56199 5.73329C8.61488 6.09729 8.60377 6.41007 8.52866 6.67163C8.45333 6.93318 8.31821 7.15285 8.12333 7.33063L5.04399 10.3283C5.53955 11.2358 6.10577 12.0944 6.74266 12.904C7.37932 13.7133 8.06866 14.4863 8.81066 15.223C9.54221 15.9547 10.32 16.6343 11.144 17.2616C11.968 17.889 12.8578 18.4727 13.8133 19.013L16.8053 15.995C17.014 15.7778 17.2667 15.6256 17.5633 15.5383C17.8598 15.4512 18.1679 15.4298 18.4877 15.4743L22.19 16.2283C22.5267 16.3172 22.8014 16.489 23.0143 16.7436C23.2272 16.9983 23.3337 17.2872 23.3337 17.6103V21.9333C23.3337 22.3333 23.1991 22.6666 22.93 22.9333C22.6609 23.2 22.3244 23.3333 21.9207 23.3333ZM4.09766 8.43596L6.47732 6.15896C6.51999 6.12474 6.54777 6.07774 6.56066 6.01796C6.57355 5.95818 6.57144 5.90263 6.55433 5.85129L5.97466 2.87163C5.95755 2.8034 5.92766 2.75218 5.88499 2.71796C5.84233 2.68374 5.78677 2.66663 5.71833 2.66663H2.86699C2.81566 2.66663 2.77288 2.68374 2.73866 2.71796C2.70466 2.75218 2.68766 2.79496 2.68766 2.84629C2.75588 3.7574 2.90499 4.68296 3.13499 5.62296C3.36477 6.56318 3.68566 7.50085 4.09766 8.43596ZM15.6977 19.959C16.5814 20.371 17.5032 20.686 18.463 20.904C19.423 21.1217 20.32 21.2512 21.154 21.2923C21.2053 21.2923 21.2481 21.2752 21.2823 21.241C21.3165 21.2067 21.3337 21.164 21.3337 21.1126V18.3076C21.3337 18.2392 21.3165 18.1836 21.2823 18.141C21.2481 18.0983 21.1969 18.0684 21.1287 18.0513L18.3287 17.482C18.2773 17.4648 18.2324 17.4627 18.194 17.4756C18.1555 17.4885 18.1149 17.5163 18.072 17.559L15.6977 19.959Z" fill="white"/>
														</svg>
														<span className='ms-3'>Phone</span>
													</p>				
													<Link to="tel:+918448848662" className="text-white" style={{fontWeight:"300"}}>+91 84488 48662</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature4 h-100">
										<div className="icon-md feature-icon">
											<img src={icon1} alt="" style={{height: "36.87px"}} />
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Contact Number</h5>
											<p>+91 84488 48662</p>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature3 h-100">
										<div className="icon-md feature-icon">
											<img src={icon3} alt="" style={{height: "39.84px"}} />
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Email Address</h5>
											<p>info@avenrahealthcenter.in</p>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature2 h-100">
										<div className="icon-md feature-icon">
											<img src={icon2} alt="" style={{height: "48.2px"}} />
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Address</h5>
											<p>Plot No. 94B, Second Floor, Udyog Vihar Phase V Rd, Udyog Vihar, Sector 19, Gurugram, Haryana 122016</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				
				</div>
				
			</>
		);
	}


export default ContactUs;